module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "hero"
    }
  }, [_c('div', {
    staticClass: "hero header-image",
    class: {
      'is-primary': _vm.isPrimary
    }
  }, [_c('div', {
    staticClass: "hero-head"
  }, [_c('nav-bar')], 1), _vm._v(" "), _c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container has-text-centered"
  }, [_vm._m(0), _vm._v(" "), _c('separator', {
    attrs: {
      "color": "white"
    }
  }), _vm._v(" "), _c('h5', {
    staticClass: "subtitle is-5"
  }, [_vm._v(_vm._s(_vm.subtitle))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "hero-foot"
  }, [_c('div', {
    staticClass: "container has-text-centered"
  }, [_c('a', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#about'),
      expression: "'#about'"
    }]
  }, [_c('i', {
    staticClass: "fa fa-chevron-down scroll-down"
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image logotype"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/img/logo.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2f31a3d5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hero.vue
// module id = 541
// module chunks = 1